import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

// Enregistrement d'une police standard
// Helvetica est supportée nativement

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    backgroundColor: '#fff',
  },
  headerInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    fontSize: 9,
    color: '#7f8c8d',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 5,
  },
  banner: {
    backgroundColor: '#1B4E6B',
    padding: 25,
    marginBottom: 30,
    alignItems: 'center',
    borderRadius: 4,
  },
  titleBanner: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 8,
    textTransform: 'uppercase',
  },
  subtitleBanner: {
    color: 'white',
    fontSize: 12,
    textAlign: 'center',
    fontWeight: 'normal',
    opacity: 0.9,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.3)',
    width: '80%',
    marginVertical: 8,
  },
  section: {
    marginBottom: 25,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1B4E6B',
    marginBottom: 15,
    backgroundColor: '#f8f9fa',
    padding: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#1B4E6B',
  },
  subsectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: 10,
    marginTop: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 3,
  },
  text: {
    fontSize: 10,
    color: '#333',
    lineHeight: 1.6,
  },
  table: {
    width: '100%',
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  tableHeader: {
    backgroundColor: '#1B4E6B',
  },
  tableCellHeader: {
    padding: 8,
    fontSize: 9,
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
  },
  tableCell: {
    padding: 8,
    fontSize: 9,
    color: '#333',
  },
  verticalTable: {
    width: '100%',
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  verticalTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  verticalTableLabel: {
    width: '35%',
    backgroundColor: '#1B4E6B',
    color: 'white',
    padding: 10,
    fontSize: 10,
    fontWeight: 'bold',
  },
  verticalTableValue: {
    width: '65%',
    padding: 10,
    fontSize: 10,
    color: '#333',
  },
  kpiContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 15,
    marginVertical: 10,
  },
  kpiCard: {
    width: '45%',
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    backgroundColor: '#fdfdfd',
    flexDirection: 'row',
    alignItems: 'center',
  },
  kpiIcon: {
    width: 25,
    height: 25,
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
  },
  kpiLabel: {
    fontSize: 8,
    color: '#7f8c8d',
    marginBottom: 2,
  },
  kpiValue: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  progressionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 25,
    marginTop: 10,
  },
  progressionBox: {
    width: '35%',
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    textAlign: 'center',
  },
  progressionArrow: {
    width: '20%',
    alignItems: 'center',
  },
  questionCard: {
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#f1f5f9',
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  // Star styling improved
  starContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
  },
  starLabel: {
    fontSize: 10,
    color: '#f1c40f',
  },
  starEmptyLabel: {
    fontSize: 10,
    color: '#e0e0e0',
  },
  conclusionBox: {
    marginTop: 20,
    padding: 20,
    backgroundColor: '#F1F5F9',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
  },
  footer: {
    position: 'absolute',
    bottom: 25,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 8,
    color: '#95a5a6',
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingTop: 10,
  },
  subTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#1B4E6B',
    marginBottom: 8,
    marginTop: 15,
  },
  remarksTable: {
    marginTop: 10,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 5,
    overflow: 'hidden',
  },
  remarksHeader: {
    backgroundColor: '#f1f5f9',
    flexDirection: 'row',
    padding: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  remarksRow: {
    flexDirection: 'row',
    padding: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f1f5f9',
  },
  remarksText: {
    fontSize: 8,
    color: '#475569',
    lineHeight: 1.4,
  },
  doughnutContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    marginTop: 10,
  },
});

const getCategory = (percentage) => {
  const p = parseFloat(percentage);
  if (p < 50) return 'APPRENTI';
  if (p < 75) return 'INTERMEDIAIRE';
  if (p <= 90) return 'CONFIRME';
  return 'EXPERT';
};

const getExpectedProgression = (prePercentage) => {
  const p = parseFloat(prePercentage);
  if (p < 50) return 'Niveau intermédiaire, soit +30%';
  if (p < 75) return 'Niveau confirmé soit +30%';
  if (p <= 90) return 'Niveau confirmé soit de +3 à +7%';
  return 'Niveau expert, soit de 0% à 3%';
};

const StarRating = ({ rating }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    // Utilisation d'un point ou d'un carré si le symbole ★ pose problème
    stars.push(
      <Text key={i} style={i <= rating ? styles.starLabel : styles.starEmptyLabel}>
        {i <= rating ? '★' : '☆'}
      </Text>
    );
  }
  return <View style={styles.starContainer}>{stars}</View>;
};

const SatisfactionReportPDF = ({ data }) => {
  const progVal = parseFloat(data.progression?.global || 0);
  const postAvg = parseFloat(data.postFormation?.average_on_20 || 0);
  const satisfVal = parseFloat(data.globalSatisfaction || 0);
  
  // Nouveaux critères demandés par l'utilisateur
  const isPedagogicSuccess = postAvg >= 10; // 10/20 correspond à 50%
  const isLogisticSuccess = satisfVal >= 70;
  const isGlobalSuccess = isPedagogicSuccess && isLogisticSuccess;

  return (
    <Document>
      {/* PAGE 1: RÉCAPITULATIF */}
      <Page size="A4" style={styles.page}>
        <View style={styles.headerInfo}>
          <Text>{data.organism} — Rapport de session</Text>
          <Text>{data.date}</Text>
        </View>
        <View style={styles.banner}>
          <Text style={styles.titleBanner}>Rapport de compte rendu de session</Text>
          <View style={styles.divider} />
          <Text style={styles.subtitleBanner}>{data.formationName}</Text>
        </View>
        <View style={styles.section}>
          <View style={styles.verticalTable}>
            {[['Session', data.sessionNumber], ['Formation', data.formationName], ['Lieu', data.location], ['Date', data.date], ['Organisme', data.organism], ['Nombre de participants', data.speciality ? `${data.speciality} - ${data.participantsCount}` : data.participantsCount], ['Questionnaires', data.questionnairesList]].map(([label, value], i) => (
              <View style={[styles.verticalTableRow, i === 6 && { borderBottomWidth: 0 }]} key={i}>
                <Text style={styles.verticalTableLabel}>{label}</Text>
                <Text style={styles.verticalTableValue}>{value}</Text>
              </View>
            ))}
          </View>
        </View>
        <Text style={styles.footer}>Document confidentiel — Page 1 / 5</Text>
      </Page>

      {/* PAGE 2: LISTE DES PARTICIPANTS */}
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>1. Liste des participants et suivi des réponses</Text>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <View style={{ width: '40%' }}><Text style={styles.tableCellHeader}>Nom et Prénom</Text></View>
              <View style={{ width: '20%' }}><Text style={styles.tableCellHeader}>Pré-formation</Text></View>
              <View style={{ width: '20%' }}><Text style={styles.tableCellHeader}>Post-formation</Text></View>
              <View style={{ width: '20%' }}><Text style={styles.tableCellHeader}>Satisfaction</Text></View>
            </View>
            {data.learners?.map((learner, index) => (
              <View style={[styles.tableRow, { backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }]} key={index}>
                <View style={{ width: '40%' }}><Text style={styles.tableCell}>{learner.name}</Text></View>
                <View style={{ width: '20%', textAlign: 'center' }}><Text style={[styles.tableCell, { color: learner.pre === 'Oui' ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }]}>{learner.pre}</Text></View>
                <View style={{ width: '20%', textAlign: 'center' }}><Text style={[styles.tableCell, { color: learner.post === 'Oui' ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }]}>{learner.post}</Text></View>
                <View style={{ width: '20%', textAlign: 'center' }}><Text style={[styles.tableCell, { color: learner.satisfaction === 'Oui' ? '#27ae60' : '#e74c3c', fontWeight: 'bold' }]}>{learner.satisfaction}</Text></View>
              </View>
            ))}
          </View>
        </View>
        <Text style={styles.footer}>Document confidentiel — Page 2 / 5</Text>
      </Page>

      {/* PAGE 3: ÉVALUATION DES CONNAISSANCES */}
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>2. Evaluation des connaissances & KPIs</Text>
          <View style={{ backgroundColor: '#f8fafc', padding: 10, borderRadius: 4, marginBottom: 15, borderLeftWidth: 3, borderLeftColor: '#cbd5e1' }}>
            <Text style={{ fontSize: 9, color: '#475569' }}>
              Le questionnaire QCM comporte {data.preFormation?.questions_count || data.postFormation?.questions_count || 'X'} questions. 
              Les résultats sont exprimés en pourcentage et classés par catégorie.
            </Text>
          </View>
          <Text style={styles.subsectionTitle}>2.1 Pré-Formation</Text>
          {data.preFormation && (
            <>
              <View style={styles.kpiContainer}>
                <View style={[styles.kpiCard, { width: '60%' }]}>
                  <View style={[styles.kpiIcon, { backgroundColor: '#eef2ff' }]}><Text style={{fontSize: 12}}>📈</Text></View>
                  <View>
                    <Text style={styles.kpiLabel}>Moyenne Globale</Text>
                    <Text style={styles.kpiValue}>
                      {data.preFormation.average_percent}% ({getCategory(data.preFormation.average_percent)})
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <View style={{ width: '50%' }}><Text style={styles.tableCellHeader}>Nom et Prénom</Text></View>
                  <View style={{ width: '20%' }}><Text style={styles.tableCellHeader}>Score (%)</Text></View>
                  <View style={{ width: '30%' }}><Text style={styles.tableCellHeader}>Catégorie</Text></View>
                </View>
                {data.preFormation.scores?.map((score, index) => {
                  const p = (score.raw_score / score.total) * 100;
                  return (
                    <View style={[styles.tableRow, { backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }]} key={index}>
                      <View style={{ width: '50%' }}><Text style={styles.tableCell}>{score.name}</Text></View>
                      <View style={{ width: '20%', textAlign: 'center' }}><Text style={styles.tableCell}>{p.toFixed(1)}%</Text></View>
                      <View style={{ width: '30%', textAlign: 'center' }}><Text style={styles.tableCell}>{getCategory(p)}</Text></View>
                    </View>
                  );
                })}
              </View>
            </>
          )}
          <Text style={styles.subsectionTitle}>2.2 Post-Formation</Text>
          {data.postFormation && (
            <>
              <View style={styles.kpiContainer}>
                <View style={[styles.kpiCard, { width: '60%' }]}>
                  <View style={[styles.kpiIcon, { backgroundColor: '#eef2ff' }]}><Text style={{fontSize: 12}}>📊</Text></View>
                  <View>
                    <Text style={styles.kpiLabel}>Moyenne Globale</Text>
                    <Text style={styles.kpiValue}>
                      {data.postFormation.average_percent}% ({getCategory(data.postFormation.average_percent)})
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={[styles.tableRow, styles.tableHeader]}>
                  <View style={{ width: '50%' }}><Text style={styles.tableCellHeader}>Nom et Prénom</Text></View>
                  <View style={{ width: '20%' }}><Text style={styles.tableCellHeader}>Score (%)</Text></View>
                  <View style={{ width: '30%' }}><Text style={styles.tableCellHeader}>Catégorie</Text></View>
                </View>
                {data.postFormation.scores?.map((score, index) => {
                  const p = (score.raw_score / score.total) * 100;
                  return (
                    <View style={[styles.tableRow, { backgroundColor: index % 2 === 0 ? '#fff' : '#fcfcfc' }]} key={index}>
                      <View style={{ width: '50%' }}><Text style={styles.tableCell}>{score.name}</Text></View>
                      <View style={{ width: '20%', textAlign: 'center' }}><Text style={styles.tableCell}>{p.toFixed(1)}%</Text></View>
                      <View style={{ width: '30%', textAlign: 'center' }}><Text style={styles.tableCell}>{getCategory(p)}</Text></View>
                    </View>
                  );
                })}
              </View>
            </>
          )}
        </View>
        <Text style={styles.footer}>Document confidentiel — Page 3 / 5</Text>
      </Page>

      {/* PAGE 4: ANALYSE ET INTERPRÉTATION */}
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>3. Analyse et interpretation : Pré/Post Formation</Text>
          <Text style={[styles.text, { fontStyle: 'italic', color: '#64748B', marginBottom: 20 }]}>
            Cette partie a pour but d'analyser et interpreter les resultat de pré-formation / Post-formation, afin d'avoir une déduction pour avoir l'evolution etc.
          </Text>
          <View style={styles.progressionHeader}>
            <View style={[styles.progressionBox, { borderTopWidth: 3, borderTopColor: '#6366F1', minHeight: 110 }]}>
              <Text style={{ fontSize: 8, color: '#6366F1', fontWeight: 'bold' }}>ÉVALUATION INITIALE</Text>
              <Text style={{ fontSize: 10, fontWeight: 'bold', marginVertical: 8 }}>Pré-Formation</Text>
              <Text style={{ fontSize: 20, fontWeight: 'bold', color: '#6366F1' }}>{data.preFormation?.average_percent}%</Text>
              <Text style={{ fontSize: 9, fontWeight: 'bold', color: '#6366F1', marginTop: 4 }}>({getCategory(data.preFormation?.average_percent)})</Text>
              <Text style={{ fontSize: 7, color: '#94A3B8', marginTop: 10 }}>{data.preFormation?.count || 0} réponses</Text>
            </View>
            
            <View style={[styles.progressionArrow, { width: '30%' }]}>
              <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#10B981', marginBottom: 2 }}>
                {progVal >= 0 ? '+' : ''}{data.progression?.global}%
              </Text>
              <Text style={{ color: '#10B981', fontSize: 22 }}>➔</Text>
              <Text style={{ fontSize: 7, color: '#64748B', fontWeight: 'bold', marginTop: 4 }}>
                {getCategory(data.preFormation?.average_percent)} → {getCategory(data.postFormation?.average_percent)}
              </Text>
              <View style={{ marginTop: 8, padding: 4, backgroundColor: '#eef2ff', borderRadius: 4, borderWidth: 1, borderColor: '#e0e7ff' }}>
                <Text style={{ fontSize: 6, color: '#6366F1', fontWeight: 'bold', textAlign: 'center' }}>
                  Objectif attendu: {getExpectedProgression(data.preFormation?.average_percent)}
                </Text>
              </View>
            </View>

            <View style={[styles.progressionBox, { borderTopWidth: 3, borderTopColor: '#10B981', minHeight: 110 }]}>
              <Text style={{ fontSize: 8, color: '#10B981', fontWeight: 'bold' }}>ÉVALUATION FINALE</Text>
              <Text style={{ fontSize: 10, fontWeight: 'bold', marginVertical: 8 }}>Post-Formation</Text>
              <Text style={{ fontSize: 20, fontWeight: 'bold', color: '#10B981' }}>{data.postFormation?.average_percent}%</Text>
              <Text style={{ fontSize: 9, fontWeight: 'bold', color: '#10B981', marginTop: 4 }}>({getCategory(data.postFormation?.average_percent)})</Text>
              <Text style={{ fontSize: 7, color: '#94A3B8', marginTop: 10 }}>{data.postFormation?.count || 0} réponses</Text>
            </View>
          </View>

          <Text style={[styles.subsectionTitle, { borderLeftWidth: 3, borderLeftColor: '#10B981', paddingLeft: 8, borderBottomWidth: 0 }]}>Progression par Apprenant (Tableau Comparatif)</Text>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <View style={{ width: '35%' }}><Text style={styles.tableCellHeader}>Apprenant</Text></View>
              <View style={{ width: '15%' }}><Text style={styles.tableCellHeader}>Pré (%)</Text></View>
              <View style={{ width: '15%' }}><Text style={styles.tableCellHeader}>Post (%)</Text></View>
              <View style={{ width: '35%' }}><Text style={styles.tableCellHeader}>Evolution / Catégorie</Text></View>
            </View>
            {data.progression?.learners?.map((l, i) => {
              const prePercent = l.avgPrePercent || (l.avgPre / 20) * 100;
              const postPercent = l.avgPostPercent || (l.avgPost / 20) * 100;
              const diff = postPercent - prePercent;
              const prog = prePercent > 0 ? (diff / prePercent) * 100 : (postPercent > 0 ? 100 : 0);
              return (
                <View style={[styles.tableRow, { backgroundColor: i % 2 === 0 ? '#fff' : '#f9fafb' }]} key={i} wrap={false}>
                  <View style={{ width: '35%' }}><Text style={styles.tableCell}>{l.name}</Text></View>
                  <View style={{ width: '15%', textAlign: 'center', backgroundColor: '#eef2ff' }}><Text style={styles.tableCell}>{prePercent.toFixed(1)}%</Text></View>
                  <View style={{ width: '15%', textAlign: 'center', backgroundColor: '#ecfdf5' }}><Text style={styles.tableCell}>{postPercent.toFixed(1)}%</Text></View>
                  <View style={{ width: '35%', padding: 5 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 2 }}>
                      <View style={{ width: '40%', height: 4, backgroundColor: '#f1f5f9', borderRadius: 2, marginRight: 5, overflow: 'hidden' }}>
                        <View style={{ width: `${Math.min(Math.abs(prog), 100)}%`, height: '100%', backgroundColor: prog >= 0 ? '#10B981' : '#EF4444' }} />
                      </View>
                      <Text style={{ fontSize: 7, color: prog >= 0 ? '#10B981' : '#EF4444', fontWeight: 'bold' }}>{prog >= 0 ? '+' : ''}{prog.toFixed(1)}%</Text>
                    </View>
                    <Text style={{ fontSize: 7, color: '#64748B', fontWeight: 'bold' }}>
                      {getCategory(prePercent)} → {getCategory(postPercent)}
                    </Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View style={{ marginTop: 30, padding: 15, backgroundColor: progVal >= 0 ? '#f0fdf4' : '#fef2f2', borderRadius: 10, borderLeftWidth: 5, borderLeftColor: progVal >= 0 ? '#22c55e' : '#ef4444' }}>
            <Text style={{ fontSize: 11, fontWeight: 'bold', color: progVal >= 0 ? '#166534' : '#991b1b', marginBottom: 5 }}>Synthèse de l'évolution :</Text>
            <Text style={{ fontSize: 10, color: progVal >= 0 ? '#14532d' : '#7f1d1d', lineHeight: 1.5 }}>
              L'analyse des résultats met en évidence une {progVal >= 0 ? 'progression' : 'diminution'} globale des connaissances de {Math.abs(progVal)}% entre le début et la fin de la formation. 
              Cette {progVal >= 0 ? 'augmentation' : 'diminution'} significative démontre {progVal >= 0 ? "l'efficacité" : "l'échec"} pédagogique de la session et une {progVal >= 0 ? 'excellente' : 'mauvaise'} assimilation des concepts clés par les apprenants.
            </Text>
          </View>
        </View>
        <Text style={styles.footer}>Document confidentiel — Page 4 / 5</Text>
      </Page>

      {/* PAGE 5: SATISFACTION & CONCLUSION */}
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>4. Satisfaction des participants</Text>
          
          <Text style={styles.subTitle}>4.1 Analyse globale</Text>
          {/* Average Satisfaction KPI Card */}
          <View style={[styles.kpiCard, { marginBottom: 15, width: '30%' }]}>
            <View style={[styles.kpiIcon, { backgroundColor: '#eef2ff' }]}><Text style={{fontSize: 12}}>📊</Text></View>
            <View>
              <Text style={styles.kpiLabel}>Moyenne</Text>
              <Text style={styles.kpiValue}>{data.globalSatisfaction}%</Text>
            </View>
          </View>

          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <View style={{ width: '60%' }}><Text style={styles.tableCellHeader}>Nom et Prénom de l'apprenant</Text></View>
              <View style={{ width: '40%' }}><Text style={styles.tableCellHeader}>Niveau de Satisfaction</Text></View>
            </View>
            {data.learners?.map((learner, index) => {
              const satisfPercent = parseFloat(learner.satisfaction_percent);
              const isLowSatisf = learner.has_satisfaction && satisfPercent <= 80;
              
              return (
                <View style={[styles.tableRow, { backgroundColor: index % 2 === 0 ? '#fff' : '#f9fafb' }]} key={index} wrap={false}>
                  <View style={{ width: '60%' }}><Text style={styles.tableCell}>{learner.name}</Text></View>
                  <View style={[
                    { width: '40%', textAlign: 'center', justifyContent: 'center' }, 
                    isLowSatisf && { backgroundColor: '#fee2e2' }
                  ]}>
                    {learner.has_satisfaction ? (
                      <Text style={[
                        styles.tableCell, 
                        isLowSatisf ? { color: '#dc2626', fontWeight: 'bold', fontSize: 11 } : {}
                      ]}>
                        {learner.satisfaction_percent}%
                      </Text>
                    ) : (
                      <Text style={{fontSize: 8, color: '#999'}}>Pas de réponse</Text>
                    )}
                  </View>
                </View>
              );
            })}
          </View>

          <Text style={styles.subTitle}>4.2 Recommandation</Text>
          <View style={styles.doughnutContainer}>
            <View style={{ 
              width: 80, 
              height: 80, 
              borderRadius: 40, 
              borderWidth: 8, 
              borderColor: '#10b981', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: '#fff',
              marginBottom: 10
            }}>
              <Text style={{ fontSize: 16, fontWeight: 'bold', color: '#10b981' }}>{data.satisfaction_details?.recommendation?.percent || 0}%</Text>
            </View>
            <Text style={{ fontSize: 9, color: '#1B4E6B', fontWeight: 'bold', textAlign: 'center', width: '100%' }}>
              Recommanderiez-vous notre organisme de formation ?
            </Text>
          </View>

          <Text style={styles.subTitle}>4.3 Remarques</Text>
          {data.satisfaction_details?.remarks?.length > 0 ? (
            <View style={styles.remarksTable}>
              <View style={styles.remarksHeader}>
                <View style={{ width: '30%' }}><Text style={[styles.tableCellHeader, { fontSize: 7 }]}>Apprenant</Text></View>
                <View style={{ width: '35%' }}><Text style={[styles.tableCellHeader, { fontSize: 7 }]}>Question</Text></View>
                <View style={{ width: '35%' }}><Text style={[styles.tableCellHeader, { fontSize: 7 }]}>Remarque / Avis</Text></View>
              </View>
              {data.satisfaction_details.remarks.map((item, idx) => (
                <View style={[styles.remarksRow, { backgroundColor: idx % 2 === 0 ? '#fff' : '#f9fafb' }]} key={idx} wrap={false}>
                  <View style={{ width: '30%' }}><Text style={styles.remarksText}>{item.learner}</Text></View>
                  <View style={{ width: '35%' }}><Text style={styles.remarksText}>{item.question}</Text></View>
                  <View style={{ width: '35%' }}><Text style={[styles.remarksText, { fontStyle: 'italic' }]}>"{item.answer}"</Text></View>
                </View>
              ))}
            </View>
          ) : (
            <Text style={{ fontSize: 9, color: '#94a3b8', fontStyle: 'italic', marginTop: 5 }}>Pas de remarques</Text>
          )}

          <Text style={styles.subTitle}>4.4 Thèmes suggérés</Text>
          {data.satisfaction_details?.suggested_themes?.length > 0 ? (
            <View style={{ marginTop: 5 }}>
              {data.satisfaction_details.suggested_themes.map((item, idx) => (
                <View style={{ marginBottom: 6, padding: 5, backgroundColor: '#f0fdf4', borderRadius: 4, borderLeftWidth: 3, borderLeftColor: '#22c55e' }} key={idx} wrap={false}>
                  <Text style={{ fontSize: 8, color: '#166534', fontWeight: 'bold' }}>{item.learner} :</Text>
                  <Text style={{ fontSize: 8, color: '#14532d', marginTop: 2 }}>{item.answer}</Text>
                </View>
              ))}
            </View>
          ) : (
            <Text style={{ fontSize: 9, color: '#94a3b8', fontStyle: 'italic', marginTop: 5 }}>Aucun thème suggéré</Text>
          )}
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>5. Conclusion générale</Text>
          <View style={styles.conclusionBox}>
            <Text style={[styles.text, { marginBottom: 10 }]}>
              La session de formation du {data.date} au lieu {data.location}, consacrée à la formation "{data.formationName}", présente les conclusions suivantes :
            </Text>
            
            <View style={{ marginBottom: 15 }}>
              <Text style={styles.text}>
                • <Text style={{ fontWeight: 'bold' }}>Verdict Pédagogique :</Text> {isPedagogicSuccess ? 'SUCCÈS' : 'À AMÉLIORER'} 
                {isPedagogicSuccess ? ' (Objectifs de montée en compétences atteints - Moyenne > 50%)' : ' (Note moyenne finale insuffisante)'}
              </Text>
              <Text style={styles.text}>
                • <Text style={{ fontWeight: 'bold' }}>Verdict Logistique :</Text> {isLogisticSuccess ? 'SUCCÈS' : 'À AMÉLIORER'}
                {isLogisticSuccess ? ' (Organisation et animation validées par les apprenants)' : ' (Niveau de satisfaction insuffisant)'}
              </Text>
            </View>

            <View style={{ marginTop: 5, paddingTop: 10, borderTopWidth: 1, borderTopColor: '#cbd5e1' }}>
              <Text style={[styles.text, { fontWeight: 'bold', color: '#1B4E6B' }]}>Indicateurs de performance :</Text>
              <View style={{ marginTop: 8, paddingLeft: 10 }}>
                <Text style={[styles.text, { marginBottom: 4 }]}>
                  • Taux de satisfaction global : <Text style={{ fontWeight: 'bold', color: satisfVal >= 70 ? '#10B981' : '#EF4444' }}>{data.globalSatisfaction}%</Text>
                </Text>
                <Text style={styles.text}>
                  • Note moyenne post-formation : <Text style={{ fontWeight: 'bold', color: isPedagogicSuccess ? '#10B981' : '#EF4444' }}>{((postAvg/20)*100).toFixed(0)}%</Text>
                </Text>
                <Text style={[styles.text, { marginTop: 4, color: '#64748B', fontStyle: 'italic' }]}>
                  Note explicative : On observe une progression globale de {progVal >= 0 ? '+' : ''}{progVal}% entre le début et la fin de la formation.
                </Text>
              </View>
            </View>
          </View>
        </View>
        <Text style={styles.footer}>Document confidentiel — Page 5 / 5</Text>
      </Page>
    </Document>
  );
};

export default SatisfactionReportPDF;
